"use client";
import {
  MotionStack,
  MotionTypography,
  MotionVariantProps,
} from "@cc/motion-components";
import { H4 } from "@theme/components/typography.fontvariant";
import line from "@c/caseStudy/images/Line 1322.svg";
import { MaterialImage } from "@cc/material-components";

export interface InitiativeDetailsStatisticsProps {
  data: {
    count: string;
    title: string;
  }[];
}

const InitiativeDetailsStatistics = (
  props: InitiativeDetailsStatisticsProps,
) => {
  const { data } = props;
  return (
    <MotionStack
      direction={"row"}
      justifyContent={"space-evenly"}
      initial={"initial"}
      whileInView={"animate"}
      viewport={{ once: true }}
      variants={staggerDiv}
      mt={{ xs: 3, md: 1 }}
      mb={{ xs: 3, md: 6 }}
      py={{ xs: 2, md: 4 }}
      border={"1px solid"}
      borderLeft={"none"}
      borderRight={"none"}
      borderColor={"secondary.500"}
      divider={<MaterialImage src={line} alt="divider" />}
    >
      {data.map((eachCount, index: number) => (
        <MotionStack
          key={`${eachCount.title}-${index}`}
          alignItems={"center"}
          spacing={1}
          variants={staggerStackChildren}
          initial={"initial"}
          whileInView={"animate"}
          viewport={{ once: true }}
        >
          <MotionTypography
            variant="h1"
            color={"primary.main"}
            fontSize={H4}
            fontWeight={{ xs: 400, md: 700 }}
            variants={staggerTextChildren}
          >
            {eachCount.count}
          </MotionTypography>
          <MotionTypography
            variant={"body2"}
            color={`primary.main`}
            textAlign={"center"}
            variants={staggerTextChildren}
          >
            {eachCount.title}
          </MotionTypography>
        </MotionStack>
      ))}
    </MotionStack>
  );
};

export default InitiativeDetailsStatistics;

const staggerDiv: MotionVariantProps = {
  initial: {},
  animate: {
    transition: {
      staggerChildren: 0.4,
    },
  },
};

const staggerStackChildren: MotionVariantProps = {
  initial: { opacity: 0.9 },
  animate: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
      duration: 0.7,
    },
  },
};

const staggerTextChildren: MotionVariantProps = {
  initial: {
    opacity: 0,
    y: "100%",
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
    },
  },
};
